"use client"

import {observer} from "mobx-react";
import * as React from 'react';
import {getDistrict} from "../../utils/SchoolBlocksUtilities";
import {Button} from "@radix-ui/themes";
import OrganizationBlockObject from "../blocks/SchoolBlocks/BlockObjects/OrganizationBlockObject";
import ClickableLink from "./ClickableLink";
import {useStores} from "../../stores/useStores";
import {searchEnum} from "../../hooks/usePagesSearch";

const CTAButton: React.FC<{
    buttonData: ButtonData,
    [restProps: string]: any,
}> = observer((props) => {
    const {modalStore, organizationStore} = useStores();
    const {navigationObj, href, ...restProps} = props;

    let orgId = props.buttonData.buttonLinkOrgId;

    let blockModel: BaseOrganization;
    if (props.buttonData.buttonContext === searchEnum.STATIC_CONTACT_US) {
        if (organizationStore.organization.type === "district") {
            blockModel = organizationStore.organization as BaseOrganization;
        }
        else {
            blockModel = getDistrict(organizationStore.organization) as BaseOrganization;
        }
        return <Button {...restProps} onClick={() => modalStore.addModal({
            type: "schoolDistrict",
            orgId,
            id: orgId,
            blockObj: new OrganizationBlockObject(blockModel?.type, {
                id: orgId,
                blockType: blockModel?.type,
                blockModel: blockModel as OrganizationTypeOrganization,
            } as any),
        } as ISchoolDistrictOrganizationModalObj)}>
            {props.children}
        </Button>
    }
    else {
        return (
            <ClickableLink href={props.buttonData.buttonLink || `/pages/${props.buttonData.buttonLinkOrgId}`} prependLocale={false} {...restProps}>
                {props.children}
            </ClickableLink>)
    }
});

export default CTAButton;
